module.exports = __webpack_public_path__ + "img/portraits_01_V.cb7ee43a.webp";